module.exports = __webpack_public_path__ + "static/profile-9ce7fff8a31960e12bb8bac32d69408f.png";